import * as React from 'react';
import {useEffect} from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

import Typography from '@mui/material/Typography';
import "./mobilestepper.scss";
import {Banner} from "../../../modals/types/banner";
import Button from "../../../core/button/button";
import {useNavigate} from "react-router-dom";

const steps = ['هدف تبلیغات', 'بودجه', 'پیشنهاد ما', 'رسانه ها', 'پرداخت'];

interface IMobileStepper {
    elements: JSX.Element[];
    sideElements: Banner[];
    setImage: React.Dispatch<React.SetStateAction<string>>;
    setTitle: React.Dispatch<React.SetStateAction<string>>;
    setBody: React.Dispatch<React.SetStateAction<string>>;
}

export default function MobileStepper({elements, sideElements, setImage, setTitle, setBody}: IMobileStepper) {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const navigte = useNavigate();

    const handleNext = () => {
        let newSkipped = skipped;

        const newActiveStep = activeStep + 1;
        if (newActiveStep >= steps.length) {
            return
        }

        setActiveStep(newActiveStep);
        setSkipped(newSkipped);
        setImage(sideElements[newActiveStep].image);
        setTitle(sideElements[newActiveStep].title);
        setBody(sideElements[newActiveStep].body);
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    };

    const handleBack = () => {
        const newActiveStep = activeStep - 1;
        if (newActiveStep < 0) {
            navigte('/');
            return
        }
        setActiveStep(newActiveStep);
        setImage(sideElements[newActiveStep].image);
        setTitle(sideElements[newActiveStep].title);
        setBody(sideElements[newActiveStep].body);
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    };

    useEffect(() => {
        setImage(sideElements[0].image);
        setTitle(sideElements[0].title);
        setBody(sideElements[0].body);
    }, [])

    return (
        <div className="Mobile-Stepper">
            <Box sx={{maxWidth: 1000}}>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel
                                optional={
                                    index === steps.length ? (
                                        <Typography variant="caption">Last step</Typography>
                                    ) : null
                                }
                            >
                                &nbsp;&nbsp;&nbsp;{label}
                            </StepLabel>
                            <StepContent>
                                <div>
                                    <Typography>{elements[activeStep]}</Typography>
                                    <Box className="d-flex flex-lg-row flex-md-row flex-sm-column flex-column" sx={{
                                        justifyContent: 'center',
                                        gap: '20px',
                                        pt: 15
                                    }}>
                                        <Button
                                            action={handleBack}
                                            responsive={false}
                                            type={"primary-light"}>
                                            {activeStep === 0 ? "→ بازگشت به پنل" : activeStep === 4 ? "ویرایش اطلاعات" : "→ مرحله قبل"}
                                        </Button>
                                        <Button action={handleNext} responsive={false} type={"primary"}>
                                            {activeStep === steps.length - 1 ? 'پرداخت' : 'تایید و ادامه ←'}
                                        </Button>
                                    </Box>
                                </div>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </div>
    );
}
